import { Icon } from '../common/Icons';
import Wrapper from '../common/Wrapper/Wrapper';
import {
  StyledSortCont,
  StyledLine,
  StyledContent,
  StyledText,
  StyledButton,
} from './ArticleSort.styles';

function ArticleSort({ onChoose }) {
  const onClick = () => {
    const value = 'Top';

    return onChoose + value;
  };

  return (
    <Wrapper>
      <StyledSortCont>
        <StyledLine> </StyledLine>
        <StyledContent>
          <StyledText>Sort by: </StyledText>
          <StyledButton type="button" onClick={onClick}>
            <span>Top</span>
            <Icon.ArrowSolid aria-hidden />
          </StyledButton>
        </StyledContent>
      </StyledSortCont>
    </Wrapper>
  );
}

export default ArticleSort;
